import path from 'path'
import consola from 'consola'
import { uniqBy } from 'lodash'
import { uiStore } from 'beisheim/store/ui'
import { viewportStore } from 'beisheim/store/viewport'
import { cookieStore } from 'beisheim/store/cookies'

export default {
  editorModes: {
    default: ['bold', 'italic', 'bullist', 'numlist', 'link', 'unlink', 'pageBrowser']
  },
  store: {
    modules: {
      ui: uiStore,
      viewport: viewportStore,
      cookies: cookieStore
    }
  },
  resourcesFilter (resources, ctx) {
    const { route } = ctx
    const rootPath = process.env.ROOT_PATH || ''
    const globals = ['CountryFolder', 'LanguageFolder']
    const globalResources = resources.filter(r =>
      (globals.includes(r.resource_class_name) && r.path.startsWith(rootPath)) ||
      // include old version assets
      (r.url && r.url.indexOf('/content') === 0)
    )

    consola.withTag('NuxtServerInit').info('Number of filtered global resources:', globalResources.length)

    const { country, language } = route.params

    let resourcesBySite = []
    if (country && language) {
      const sitePath = path.join(rootPath, country, language)
      resourcesBySite = resources.filter(r => r.path.startsWith(sitePath))
    }

    return uniqBy([...resourcesBySite, ...globalResources], 'path')
  },
  cache: {
    minCachePathDepth: 2
  }
}
